import React, { useEffect, useState, useContext } from 'react';
import { Typography, Box, Paper } from '@mui/material';
import AddUserForm from '../components/AddUserForm';
import UserTable from '../components/UserTable';
import SnackbarAlert from '../components/SnackbarAlert';
import { AuthContext } from '../context/AuthContext'; 
import { fetchUsers, addUser, toggleAdmin, toggleCanBook, deactivateUser, updateElectricCar } from '../api/users';


function ManageUsersPage() {
  const { userInfo } = useContext(AuthContext);
  const currentUserId = userInfo?.id;

  const [users, setUsers] = useState([]);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

  const loadUsers = async () => {
    try {
      const data = await fetchUsers();
      setUsers(data.users || []);
    } catch (err) {
      setSnackbar({ open: true, message: err.message, severity: 'error' });
    }
  };

  const handleAddUser = async (email) => {
    try {
      const data = await addUser(email);
      setSnackbar({ open: true, message: data.message, severity: 'success' });
      loadUsers();
    } catch (err) {
      setSnackbar({ open: true, message: err.message, severity: 'error' });
    }
  };

  const handleToggleAdmin = async (userId) => {
    try {
      const data = await toggleAdmin(userId);
      setSnackbar({ open: true, message: data.message, severity: 'success' });
      loadUsers();
    } catch (err) {
      setSnackbar({ open: true, message: err.message, severity: 'error' });
    }
  };

  const handleToggleCanBook = async (userId) => {
    try {
      const data = await toggleCanBook(userId);
      setSnackbar({ open: true, message: data.message, severity: 'success' });
      loadUsers();
    } catch (err) {
      setSnackbar({ open: true, message: err.message, severity: 'error' });
    }
  };

  const handleDeactivateUser = async (userId) => {
    try {
      const data = await deactivateUser(userId);
      setSnackbar({ open: true, message: data.message, severity: 'success' });
      loadUsers();
    } catch (err) {
      setSnackbar({ open: true, message: err.message, severity: 'error' });
    }
  };

  const handleToggleElectricCar = async (userId) => {
    try {
      const data = await updateElectricCar(userId);
      setSnackbar({ open: true, message: data.message, severity: 'success' });
      loadUsers();
    } catch (err) {
      setSnackbar({ open: true, message: err.message, severity: 'error' });
    }
  };

  useEffect(() => {
    loadUsers();
  }, []);

  return (
    <Box sx={{ p: 2 }}>
     <Paper sx={{ p: 2, mb: 4 }}>
        <Typography variant="h6" gutterBottom>Add User</Typography>
        <AddUserForm onAdd={handleAddUser} />
      </Paper>

      <UserTable 
        users={users} 
        onToggleAdmin={handleToggleAdmin} 
        onToggleCanBook={handleToggleCanBook}
        onDeactivate={handleDeactivateUser} 
        onToggleElectricCar={handleToggleElectricCar} 
        currentUserId={currentUserId}
      />

      <SnackbarAlert 
        open={snackbar.open} 
        message={snackbar.message} 
        severity={snackbar.severity} 
        onClose={() => setSnackbar({ ...snackbar, open: false })} 
      />
    </Box>
  );
}

export default ManageUsersPage;